module.exports = __webpack_public_path__ + "img/Tinker64_128.e2770fd2.png";